import { useState, useCallback } from 'react'

const toggleBoolean = (currentValue) => !currentValue

export const useToggle = (initialState = false) => {
  const [toggled, setToggle] = useState(initialState)

  const toggle = useCallback(() => {
    setToggle(toggleBoolean)
  }, [setToggle, toggleBoolean])

  const on = useCallback(() => {
    setToggle(true)
  }, [setToggle])

  const off = useCallback(() => {
    setToggle(false)
  }, [setToggle])

  return {
    toggle,
    off,
    on,
    value: toggled,
  }
}
